import React from 'react';
import PasskeyRegistrationForm from './components/PasskeyRegistrationForm.tsx';

const RegistrationPage: React.FC = () => {
  return <PasskeyRegistrationForm />;
};

export default RegistrationPage;
